import { initializeParameters } from './init';
import { parameterCollection } from './parameterCollection';

const validateThePresenceOfParameters = () => window.location.search.substr(1).length > 0;
const separateParameterKeysAndValues = (parameterBlock: string) => parameterBlock.split('=');
const getParameterValuesArray = (parameterValues: string) => parameterValues.split(',');

const getParameterValueMethod = (key: string, value: string) => {
  const parameter = parameterCollection.find((myParameter) => myParameter.key === key);
  const parameterValue = parameter
    ? parameter.values.find((parameterValue) => parameterValue.key === value)
    : false;

  return parameterValue ? parameterValue.method : false;
};

const executeParameterMethods = (key: string, values: Array<string>) => {
  for (let i = 0; i < values.length; i++) {
    const method = getParameterValueMethod(key, values[i]);

    if (method) {
      method();
    }
  }
};

const executeParameters = (parameterStringsArray: Array<string>) => {
  for (let i = 0; i < parameterStringsArray.length; i++) {
    const parameterKeyValuesArray = separateParameterKeysAndValues(parameterStringsArray[i]);

    if (parameterKeyValuesArray.length <= 1) {
      continue;
    }

    const key = parameterKeyValuesArray[0];
    const values = getParameterValuesArray(parameterKeyValuesArray[1]);
    executeParameterMethods(key, values);
  }
};

export const parseUrlParameters = () => {
  initializeParameters();
  if (validateThePresenceOfParameters()) {
    const url = window.location.search.substr(1);
    const parameterStringsArray = url.split('&');
    window.history.replaceState({}, document.title, '/');
    executeParameters(parameterStringsArray);
  }
};
